export default [
    {path: ':crop_id/:year'},
    {path: ':crop_id/:year/edit/:variety_id'},
    {path: ':crop_id/:year/details/:variety_id'},
]